import React from "react";
import "./ui.scss";

const PENDING = ["requested", "pending"];
const REVOKED = ["revoke", "revoked"];
const CANCELLED = ["cancel", "canceled", "cancelled", "withdrawn"];

/**
 * Maps whatever status string the backend sends onto a small fixed set of
 * keys used for colours, tab filtering and summary counts:
 *   pending | approved | rejected | cancelled | neutral | none
 * "Revoke"/"Revoked" and "Cancel(l)ed" both land in `cancelled`; the label
 * keeps the distinction.
 */
export const normalizeStatus = (raw, { pendingLabel = "Pending" } = {}) => {
  const value = String(raw === null || raw === undefined ? "" : raw)
    .trim()
    .toLowerCase();

  if (!value) return { key: "none", label: "" };
  if (PENDING.includes(value)) return { key: "pending", label: pendingLabel };
  if (value === "approved") return { key: "approved", label: "Approved" };
  if (value === "rejected") return { key: "rejected", label: "Rejected" };
  if (REVOKED.includes(value)) return { key: "cancelled", label: "Revoked" };
  if (CANCELLED.includes(value)) {
    return { key: "cancelled", label: "Cancelled" };
  }
  return { key: "neutral", label: String(raw) };
};

const StatusBadge = ({ status, pendingLabel }) => {
  const { key, label } = normalizeStatus(status, { pendingLabel });
  if (key === "none") return <span className="hr-muted">N/A</span>;
  return <span className={`hr-badge hr-badge--${key}`}>{label}</span>;
};

export default StatusBadge;
